import { z } from 'zod';

export const AccountMappingSuggestionActionSchema = z.enum(['MAP', 'CREATE']);

export const AccountMappingSuggestionSchema = z
  .object({
    slotId: z.string(),
    action: AccountMappingSuggestionActionSchema,
    glAccountId: z.string().nullish(),
    confidence: z.number().min(0).max(1),
    reason: z.string(),
    suggestedAccountName: z.string().nullish(),
    suggestedAccountCode: z.string().nullish(),
    suggestedParentCode: z.string().nullish(),
  })
  .strict();

export const AccountMappingSuggestionResultSchema = z
  .object({
    suggestions: z.array(AccountMappingSuggestionSchema),
  })
  .strict();

export type AccountMappingSuggestionAction = z.infer<typeof AccountMappingSuggestionActionSchema>;
export type AccountMappingSuggestion = z.infer<typeof AccountMappingSuggestionSchema>;
export type AccountMappingSuggestionResult = z.infer<typeof AccountMappingSuggestionResultSchema>;

/**
 * OpenAI Structured Outputs with `strict: true` requires all keys in `required`.
 * Nullable fields use `type: ['string', 'null']`.
 */
export const ACCOUNT_MAPPING_SUGGESTION_JSON_SCHEMA: Record<string, unknown> = {
  type: 'object',
  properties: {
    suggestions: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          slotId: { type: 'string' },
          action: { type: 'string', enum: ['MAP', 'CREATE'] },
          glAccountId: { type: ['string', 'null'] },
          confidence: { type: 'number' },
          reason: { type: 'string' },
          suggestedAccountName: { type: ['string', 'null'] },
          suggestedAccountCode: { type: ['string', 'null'] },
          suggestedParentCode: { type: ['string', 'null'] },
        },
        required: [
          'slotId',
          'action',
          'glAccountId',
          'confidence',
          'reason',
          'suggestedAccountName',
          'suggestedAccountCode',
          'suggestedParentCode',
        ],
        additionalProperties: false,
      },
    },
  },
  required: ['suggestions'],
  additionalProperties: false,
};

export interface SuggestAccountMappingsRequest {
  mode: 'TAX' | 'SYSTEM' | 'ROOT';
}

export interface AccountMappingSuggestionCacheEntry {
  mode: 'ROOT' | 'SYSTEM' | 'TAX';
  versionId: string;
  suggestions: AccountMappingSuggestion[];
  createdAt: string;
}
